import { useEffect } from "react";
import { useLocation } from "react-router-dom";

function BodyClassManager() {
  const location = useLocation();

  useEffect(() => {
    document.body.className = location.pathname === "/" ? "home" : "subpage";
  }, [location.pathname]);

  return null;
}

export default BodyClassManager;
